/* eslint-disable no-unused-expressions */
import mediaPipePose from "./util/mediaPipePose";
import CrashRecoveryService from "./services/CrashRecoveryService"

class ondemandCamera {
  constructor() {
    this.ondemandCamera = {};
    this.userPermision = false;
    this.loadedmedia = false;
    this.listOfCameras = [];
    this.listOfSpeakers = [];
    this.currentCameraIndex = 0;

    this.cameraActive = false;

    this.audioSaidStart = false;
    this.audioSaidLight = false;

    this.pickOnce = true;

    this.localStream = null;

    this.mediaPipePose = new mediaPipePose();

    this.repeatedDetection = false;
    this.vwidth = "100vw";
    this.vheight = "100vw";
    this.aspectRatio = "16/9";

    this.framesArray = [];

    this.flutterCanvas = false;
    this.drawContext = false;
    this.drawContext1 = false;

    this.hideMasks = [];
    this.listStickMan = [];
    this.doHiding = false;

    this.useWidth = window["electron"] ? 1280 : window.innerWidth;
    this.useHeight = window["electron"] ? 720 : window.innerHeight;

    this.sizeSetupOnce = false;

    this.simpleCanvas = document.createElement("CANVAS");
    this.simpleCanvas.width = this.useWidth;
    this.simpleCanvas.height = this.useHeight;
    this.simpleCtx = this.simpleCanvas.getContext("2d");
    //this.simpleCtx.translate(this.useWidth, 0);
    //this.simpleCtx.scale(-1, 1);
    this.listOfMediaTracks = [];

    // ── Phone-call / OS-interrupt camera recovery ──────────
    this._recoveryTimer = null;
    this._recoveryAttempt = 0;
    this._MAX_RECOVERY_RETRIES = 8;
    // do NOT call isIPhoneSafari() here — class methods are not
    // available during construction. Delay is resolved at call time instead.
    this._RECOVERY_DELAY_MS = 800;

    this._muteCheckTimer = null;

    // Safari watchdog — rAF-based loop that survives JS timer freezes
    this._safariWatchdogActive = false;
    // ───────────────────────────────────────────────────────

    this.APIURL = window.location.href.indexOf('uat') > 0 || window.location.href.indexOf('weborik') > 0 || window.location.href.indexOf('ocalhost') > 0 ? 'https://uatapi.virdiohealth.com' : 'https://api.virdiohealth.com';

    // ── PAGE RESUME LISTENERS — registered immediately on instantiation ───
    //
    // Placed here in the constructor rather than in listenNative() for two
    // critical reasons:
    //
    // 1. NO TIMING GAP: listenNative() is called by Flutter after the WebView
    //    fully loads, which can be several seconds after the class is
    //    instantiated. Any visibilitychange / pageshow that fires in that
    //    window would be missed entirely. Registering here means we catch
    //    every event from the first moment the page is alive.
    //
    // 2. NO DUPLICATE LISTENERS: listenNative() can be called more than once
    //    if Flutter reinitialises the WebView. Registering listeners there
    //    would stack duplicates on every call, causing multiple simultaneous
    //    recovery loops. The constructor runs exactly once.
    //
    // All three events call the same _handlePageResume helper, which checks
    // whether the track is actually dead before acting — so if all three fire
    // at once, the second and third calls are silent no-ops.

    const _handlePageResume = () => {
      if (!this.cameraActive) return;

      const videoEl = document.querySelector('#agora_ondemand_local video');
      const trackDead = !videoEl?.srcObject ||
        // ── FIX: remove t.muted — only check readyState ──
        videoEl.srcObject.getVideoTracks().every(
          t => t.readyState === 'ended'
        );

      if (trackDead) {
        console.log('[Camera] Page resumed — track dead, restarting recovery');
        this._cancelRecovery();
        this._recoveryAttempt = 0;
        this._scheduleRecovery();
      }
    };

    // 1. visibilitychange — most reliable on Android WebView + desktop Chrome
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        _handlePageResume();
      }
    });

    // 2. pageshow — fires on Safari when returning from the call screen,
    //    a bfcache restore, or system permission dialogs. More reliable than
    //    visibilitychange inside an iOS Flutter WebView.
    window.addEventListener('pageshow', (e) => {
      console.log('[Camera] pageshow fired, persisted:', e.persisted);
      _handlePageResume();
    });

    // 3. focus — last-resort fallback. Flutter WebViews on iOS sometimes
    //    suppress both visibilitychange and pageshow after a call screen;
    //    focus still fires when the app window regains control.
    window.addEventListener('focus', () => {
      _handlePageResume();
    });

    // ── FLUTTER LIFECYCLE BRIDGE ──────────────────────────────────────────
    // Flutter calls these two functions directly via runJavaScript() whenever
    // the app lifecycle changes (AppLifecycleState.resumed / paused).
    //
    // This is the most reliable recovery signal on iOS because Flutter
    // receives the native lifecycle event BEFORE the WebView JS context is
    // fully restored, so it can proactively tell us to check the camera.
    //
    // Registered on window here (not in listenNative) so Flutter can call
    // them the instant the app resumes — even before listenNative() runs.
    //
    // Flutter side usage:
    //   _webViewController.runJavaScript('window._cameraResumeFromFlutter()');
    //   _webViewController.runJavaScript('window._cameraPauseFromFlutter()');

    window._cameraResumeFromFlutter = () => {
      console.log('[Camera] Flutter signalled resume — checking camera health');
      _handlePageResume();
    };

    window._cameraPauseFromFlutter = () => {
      console.log('[Camera] Flutter signalled pause (call screen / background)');
      // No action needed here — the track "ended" / "mute" events handle the
      // actual interruption. This log is useful for debugging timing.
    };
    this._lastCameraMode = null;
    this._lastBoxPosition = null;
  }

  hasGetUserMedia = () => {
    return !window["electron"] || !!(navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia);
  };

  onScreenEnter = (screenName) => {
    console.log('[Camera] onScreenEnter called with screenName:', screenName);
    if (!screenName) return;
    if (window.MyraInteraction && typeof window.MyraInteraction.onScreenEnter === "function") {
      window.MyraInteraction.onScreenEnter(screenName);
    }
  };

  hasCameraAccess = () => {
    // Returns 'granted', 'denied', or 'pending'
    return localStorage.getItem('cameraPermissionStatus') || 'pending';
  };

  refreshCameraPermission = () => {
    localStorage.removeItem('cameraPermissionStatus'); // mark as pending
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        stream.getTracks().forEach((track) => track.stop());
        localStorage.setItem('cameraPermissionStatus', 'granted');
      })
      .catch(() => {
        localStorage.setItem('cameraPermissionStatus', 'denied');
      });
  };

  startMicPermission = async () => {
    console.log('[MicPermission] Starting microphone permission check');

    try {
      let currentState = null;
      if (navigator.permissions && navigator.permissions.query) {
        try {
          const permissionStatus = await navigator.permissions.query({ name: 'microphone' });
          currentState = permissionStatus.state;
          console.log('[MicPermission] Current permission state:', currentState);

          //   permission changes (  for debugging)
          permissionStatus.onchange = () => {
            console.log('[MicPermission] Permission changed to:', permissionStatus.state);
          };
        } catch (permError) {
          console.warn('[MicPermission] Permissions API not fully supported:', permError);
        }
      }

      if (currentState === 'granted') {
        console.log('[MicPermission] Permission already granted');
        return true;
      }

      if (currentState === 'denied') {
        console.log('[MicPermission] Permission previously denied by user');
        return false;
      }

      console.log('[MicPermission] Requesting microphone access...');

      const constraints = this._getAudioConstraints();

      const stream = await navigator.mediaDevices.getUserMedia(constraints);

      // Success! Cleaning up the stream immediately 
      if (stream && stream.getTracks) {
        stream.getTracks().forEach(track => {
          track.stop();
          track.enabled = false;
        });
      }

      console.log('[MicPermission] Microphone permission granted');
      return true;

    } catch (error) {
      console.error('[MicPermission] Permission request failed:', error);

      // Handle specific error types
      if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
        console.log('[MicPermission] User denied microphone access');
        return false;
      }

      if (error.name === 'NotFoundError') {
        console.log('[MicPermission] No microphone found on device');
        return false;
      }

      if (error.name === 'NotReadableError') {
        console.log('[MicPermission] Microphone is already in use by another application');
        return false;
      }

      // Generic error
      console.log('[MicPermission] Unexpected error:', error.message);
      return false;
    }
  };

  _getAudioConstraints = () => {
    const ua = navigator.userAgent;
    const isMobile = /Android|webOS|iPhone|iPad|iPod/i.test(ua);
    const isMacDesktop = /Macintosh|Mac OS X/.test(ua) && !isMobile;
    if (isMacDesktop) {
      return { audio: { deviceId: 'default' } };
    } else if (isMobile) {
      return { audio: true };
    } else {
      return { audio: { deviceId: 'default' } };
    }
  };

  // ── PHONE CALL FIX: fired when OS forcibly ends a video track ─────────
  // Ignored when we stopped the camera intentionally (cameraActive=false).
  onTrackEnded = () => {
    console.log('[Camera] Track "ended" event — OS may have taken the camera');
    if (!this.cameraActive) {
      console.log('[Camera] Intentional stop — skipping recovery');
      return;
    }
    console.log('[Camera] Unexpected track end — starting recovery loop');
    this._recoveryAttempt = 0;
    this._scheduleRecovery();
  };

  // ── SAFARI FIX: Safari fires 'mute' instead of 'ended' during a call ──
  onTrackMuted = () => {
    console.log('[Camera] Track muted — possible phone call (Safari behavior)');
    if (!this.cameraActive) return;

    // Clear any previous mute check before starting a new one
    if (this._muteCheckTimer) {
      clearTimeout(this._muteCheckTimer);
      this._muteCheckTimer = null;
    }

    // Wait briefly — if it unmutes on its own it was just a brief interrupt
    this._muteCheckTimer = setTimeout(() => {
      this._muteCheckTimer = null;
      const videoEl = document.querySelector('#agora_ondemand_local video');
      const track = videoEl?.srcObject?.getVideoTracks()[0];

      if (track && track.muted) {
        console.log('[Camera] Track still muted after grace period — triggering recovery');
        this._recoveryAttempt = 0;
        this._scheduleRecovery();
      } else {
        console.log('[Camera] Track unmuted on its own — no recovery needed');
      }
    }, 1500);
  };

  // ── SAFARI FIX: fully tears down video element before each retry ───────
  // Safari will not reinitialize the camera pipeline on a reused element.
  _tearDownVideoElement = () => {
    try {
      if (this.localStream) {
        this.localStream.getVideoTracks().forEach(track => {
          try { track.removeEventListener('ended', this.onTrackEnded); } catch (_) { }
          try { track.removeEventListener('mute', this.onTrackMuted); } catch (_) { }
          try { track.stop(); } catch (_) { }
        });
        this.localStream = null;
      }

      const container = document.querySelector('#agora_ondemand_local');
      const video = container?.querySelector('video');
      if (video) {
        video.style.cssText = '';
        video.pause();
        video.srcObject = null;
        video.src = '';
        video.load();   // forces Safari to flush internal pipeline buffers
        video.remove(); // detach from DOM entirely — required for Safari
      }
      if (container) {
        container.classList.remove('safariRotation');
        container.style.cssText = '';
        container.innerHTML = '';
      }
    } catch (e) {
      console.warn('[Camera] Teardown error:', e);
    }
  };

  _scheduleRecovery = () => {
    if (this._recoveryTimer) {
      clearTimeout(this._recoveryTimer);
      this._recoveryTimer = null;
    }

    if (this._recoveryAttempt >= this._MAX_RECOVERY_RETRIES) {
      console.warn('[Camera] Max recovery attempts reached — giving up');
      return;
    }

    // Resolve Safari delay at call time (isIPhoneSafari() is safe here).
    // Give a longer initial delay on Safari — the OS needs more time to
    // release the camera hardware after the call screen dismisses.
    const delay = (this._recoveryAttempt === 0 && this.isIPhoneSafari())
      ? 2000
      : (this.isIPhoneSafari() ? 1500 : this._RECOVERY_DELAY_MS);

    this._recoveryTimer = setTimeout(() => {
      this._recoveryTimer = null;

      if (!this.cameraActive) {
        console.log('[Camera] Recovery aborted — camera intentionally stopped');
        return;
      }

      this._recoveryAttempt++;
      console.log(`[Camera] Recovery attempt ${this._recoveryAttempt}/${this._MAX_RECOVERY_RETRIES}`);

      // Full teardown required on Safari before each getUserMedia call
      this._tearDownVideoElement();

      const cam = this.getLastPickedCamera();
      this.getUserPermission(cam, false, (res) => {
        if (res) {
          console.log('[Camera] Camera recovered successfully');
          this._recoveryAttempt = 0;
          // Restart watchdog after successful recovery
          this._startSafariWatchdog();
          this._reapplyCameraStyles();
          if (window.cameraIsOn) window.cameraIsOn();
          if (window.doKeepVideoPlay) window.doKeepVideoPlay();
        } else {
          console.log('[Camera] Camera still unavailable — retrying');
          this._scheduleRecovery();
        }
      });
    }, delay);
  };

  _cancelRecovery = () => {
    if (this._recoveryTimer) {
      clearTimeout(this._recoveryTimer);
      this._recoveryTimer = null;
    }
    if (this._muteCheckTimer) {
      clearTimeout(this._muteCheckTimer);
      this._muteCheckTimer = null;
    }
    this._recoveryAttempt = 0;
    this._stopSafariWatchdog();
  };

  // ── SAFARI WATCHDOG ────────────────────────────────────────────────────
  // Uses requestAnimationFrame instead of setTimeout so it survives Safari
  // freezing JS timers when the call screen / system overlay is active.
  // rAF resumes immediately when Safari returns control to the page.
  _startSafariWatchdog = () => {
    if (!this.isIPhoneSafari()) return;
    if (this._safariWatchdogActive) return;

    this._safariWatchdogActive = true;
    console.log('[Camera] Safari watchdog started');

    const check = () => {
      if (!this._safariWatchdogActive) return;

      if (this.cameraActive && !this._recoveryTimer && !this._muteCheckTimer) {
        const videoEl = document.querySelector('#agora_ondemand_local video');
        const srcObject = videoEl?.srcObject;

        if (srcObject) {
          const tracks = srcObject.getVideoTracks();
          // ── FIX: only check readyState === 'ended', NOT t.muted ──
          // track.muted is unreliable on Safari — the video element's own
          // muted attribute causes tracks to briefly report muted=true on
          // a perfectly healthy stream. onTrackMuted() handles real mute events.
          const trackEnded = tracks.length > 0 &&
            tracks.every(t => t.readyState === 'ended');

          if (trackEnded) {
            console.log('[Camera] Watchdog detected ended track — triggering recovery');
            this._recoveryAttempt = 0;
            this._scheduleRecovery();
          }
        }
        // If no srcObject yet (stream being set up) — do nothing, not an error
      }

      requestAnimationFrame(check);
    };

    requestAnimationFrame(check);
  };

  _stopSafariWatchdog = () => {
    if (this._safariWatchdogActive) {
      this._safariWatchdogActive = false;
      console.log('[Camera] Safari watchdog stopped');
    }
  };

  _reapplyCameraStyles = () => {
    if (!this._lastCameraMode) return;

    if (this._lastCameraMode === 'stretch') {
      // stretchToFill reads from the live video element so we wait
      // for metadata to be loaded before calling it
      const video = document.querySelector('#agora_ondemand_local video');
      if (!video) return;

      if (video.readyState >= 1) {
        // Metadata already available — apply immediately
        this.stretchToFill();
      } else {
        // Wait for metadata then apply
        video.addEventListener('loadedmetadata', () => {
          this.stretchToFill();
        }, { once: true });
      }
    } else if (this._lastCameraMode === 'box' && this._lastBoxPosition) {
      // Reapply the box CSS rule with the saved position
      const pos = this._lastBoxPosition;
      const el = document.getElementById("cameraCustomRules");
      if (el) {
        el.innerHTML = `
          body.cameraSetupScreen #agora_ondemand_local video,
          body.cameraSetupScreen #agora_ondemand_local_waiting {
            position: absolute;
            left: ${pos.left}px;
            top: ${pos.top}px;
            width: ${pos.width}px;
            height: ${pos.height}px;
          }
        `;
      }
    }
  };
  // ── END PHONE CALL / SAFARI FIX ───────────────────────────────────────

  getUserPermission = (cam, callDistanceCheck, f) => {
    document.querySelector("#agora_ondemand_local").innerHTML = "";
    const _container = document.querySelector("#agora_ondemand_local");
    _container.classList.remove('safariRotation');
    _container.style.cssText = '';
    if (document.querySelector('.agora_ondemand_local_allow')) { document.querySelector('.agora_ondemand_local_allow').style.display = 'none'; }

    var makeActive = () => {
      this.cameraActive = true;
    };

    // Arrow function so `this` is available for _startSafariWatchdog
    var successCallback = (e) => {
      console.log("Accessed", e);
      if (window.cameraIsReady && !!document.querySelector("body.cameraSetupScreen")) {
        makeActive();
        console.log("Ready to begin");
        window.cameraIsReady();
      }

      f(true);

      // Start Safari watchdog after camera is successfully acquired
      this._startSafariWatchdog();
    };

    var constraints = {
      audio: false,
      video: {
        width: { min: 640, ideal: 1920 },
        height: { min: 360, ideal: 1080 },
        aspectRatio: 16 / 9,
        facingMode: "user"
      },
    };

    if (cam && cam.deviceId) {
      constraints = { video: { width: { min: 640, ideal: 1920 }, height: { min: 360, ideal: 1080 }, deviceId: { exact: cam.deviceId } } };
    }

    console.log('GET CAM', constraints, cam);

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(async (localMediaStream) => {
        console.log('GOT', localMediaStream);
        const videoTrack = localMediaStream.getVideoTracks()[0];

        let currentLabel = '';
        if (videoTrack && videoTrack.label) {
          currentLabel = videoTrack.label;
          if (window.updateCurrentCamera) {
            window.updateCurrentCamera(videoTrack.label);
          }
        }

        let devices = [];
        try {
          devices = await navigator.mediaDevices.enumerateDevices();
        } catch (e) {
          console.warn("enumerateDevices failed, cannot auto-switch from iPhone camera:", e);
        }

        this.listOfCameras = devices.filter((d) => d.kind === "videoinput");

        // --- NEW LOGIC: if first picked camera is an iPhone, auto-switch ---
        if (/iphone/i.test(currentLabel) && this.pickOnce == true) {
          console.log("Detected iPhone camera as first pick. Looking for a non-iPhone camera...");

          this.pickOnce = false;

          const nonIphoneCam = this.listOfCameras.find((cam) => !/iphone/i.test((cam.label || "")));

          if (nonIphoneCam) {
            console.log("Switching to non-iPhone camera:", nonIphoneCam.label || nonIphoneCam.deviceId);
            localMediaStream.getVideoTracks().forEach((t) => t.stop());
            this.setVideoDevice({ deviceId: [nonIphoneCam.deviceId] });
            return;
          } else {
            console.log("No non-iPhone camera found. Staying on iPhone camera.");
          }
        }
        // --- END NEW LOGIC ---

        const selectedCam = this.listOfCameras.find((cam) => currentLabel == cam.label);
        if (selectedCam && selectedCam.deviceId) {
          localStorage.setItem("virtual_camera_selected", selectedCam.deviceId);
        }

        document.querySelector("#agora_ondemand_local").innerHTML = "<video playsinline webkit-playsinline muted autoplay></video>";
        var video = document.querySelector("#agora_ondemand_local video");
        video.srcObject = localMediaStream;
        this.listOfMediaTracks.push(localMediaStream);
        this.localStream = localMediaStream;

        // ── PHONE CALL FIX: attach track listeners ────────────────────────
        localMediaStream.getVideoTracks().forEach(track => {
          track.addEventListener('ended', this.onTrackEnded);
          // Safari fires 'mute' instead of 'ended' during phone calls
          track.addEventListener('mute', this.onTrackMuted);
        });
        // ─────────────────────────────────────────────────────────────────

        video.onloadedmetadata = (e) => {
          successCallback(e);

          if (window.cameraDistanceCheck && callDistanceCheck) {
            console.log("Ready, call camera distance check #OD-CAM");
            window.cameraDistanceCheck();
          }

          if (this.isIPhoneSafari() && callDistanceCheck) {
            this.stretchToFill();
          }

          // ── SAFARI FIX: verify stream is actually live, not frozen ────────
          // Safari can return a valid-looking stream that is silently frozen.
          if (this.isIPhoneSafari()) {
            setTimeout(() => {
              const v = document.querySelector('#agora_ondemand_local video');
              if (v && (v.videoWidth === 0 || v.readyState < 2)) {
                console.warn('[Camera] Safari returned a dead stream — re-triggering recovery');
                if (this.cameraActive) {
                  this._recoveryAttempt = 0;
                  this._scheduleRecovery();
                }
              }
            }, 1000);
          }
          // ─────────────────────────────────────────────────────────────────
        };
      })
      .catch((err) => {
        f(false);
        console.log(err);
        if (document.querySelector('.agora_ondemand_local_allow')) { document.querySelector('.agora_ondemand_local_allow').style.display = 'block'; }
      });
  };

  getListOfCameras = (callback) => {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      var videoSources = [];
      var speakerSources = [];
      for (var i = 0; i < devices.length; i++) {
        var device = devices[i];
        if (device.kind === "videoinput") {
          videoSources.push(device);
        } else if (device.kind === "audiooutput") {
          speakerSources.push(device);
        }
      }

      this.listOfCameras = videoSources;

      try {
        if (window.updateCameraList && this.listOfCameras && JSON.stringify(this.listOfCameras)) {
          window.updateCameraList(JSON.stringify(this.listOfCameras));
        }
      } catch (e) { console.error('got error', e); }

      if (callback) {
        callback();
      }
    });
    return JSON.stringify(this.listOfCameras);
  };

  getListOfSpeakers = (callback) => {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      var speakerSources = [];
      for (var i = 0; i < devices.length; i++) {
        var device = devices[i];
        if (device.kind === "audiooutput") {
          speakerSources.push(device);
        }
      }

      this.listOfSpeakers = speakerSources;
      console.log("this.listOfSpeakers", this.listOfSpeakers);

      if (window.updateSpeakerList) {
        window.updateSpeakerList(JSON.stringify(this.listOfSpeakers));
      }
      //callback();
    });
    return JSON.stringify(this.listOfSpeakers);
  };

  speakerTestOnDemand = () => {
    this.audio = new Audio("assets/assets/dashboard/Stream/test_speaker.mp3");
    if (this.getLastPickedSpeaker()) {
      this.audio.setSinkId(this.getLastPickedSpeaker()["deviceId"]);
    }
    this.audio.play();
    setTimeout(() => {
      this.audio.pause();
      window.playSoundSpeaker(0);
    }, 5000);
  };

  stopSpeakerTestOnDemand = () => {
    if (this.audio) {
      this.audio.pause();
    } else if (this.audio === undefined) {
      console.log(this.audio);
    }
  };

  getLastPickedCamera = () => {
    var pickedId = localStorage.getItem("virtual_camera_selected");

    this.currentCameraIndex = 0;
    if (!pickedId && this.listOfCameras.length > 0) {
      return this.listOfCameras[0];
    }

    if (!pickedId && this.listOfCameras.length == 0) {
      return false;
    }

    var returnCam = this.listOfCameras[0];

    var i = 0;
    this.listOfCameras.forEach((cam) => {
      if (cam.deviceId == pickedId) {
        returnCam = cam;
        this.currentCameraIndex = i;
      }
      i++;
    });

    localStorage.setItem("virtual_camera_selected", returnCam && returnCam.deviceId ? returnCam.deviceId : "");

    return returnCam;
  };

  startStream = () => {
    if (this.cameraActive) {
      console.log("Stream started already....");
      if (window.cameraIsOn) { window.cameraIsOn(); }
      if (window.doKeepVideoPlay) window.doKeepVideoPlay();
      setTimeout(() => {
        if (window.cameraDistanceCheck) {
          console.log("Ready, call camera distance check #OD-CAM");
          window.cameraDistanceCheck();
          this.getListOfCameras();
        }
      }, 2000);
      return true;
    }

    console.log("called start");
    if (!this.hasGetUserMedia()) {
      console.log("Not allowed");
    } else {
      console.log("called list");
      this.getListOfCameras(() => {
        console.log("called back");
        var pickedCamera = this.getLastPickedCamera();

        this.getUserPermission(pickedCamera, true, (res) => {
          if (res) {
            console.log("Stream started....");
            this.cameraActive = true;
            if (window.cameraIsOn) { window.cameraIsOn(); }
            if (window.doKeepVideoPlay) window.doKeepVideoPlay();
          } else {
            // Ask for permission
            console.log("Camera REJECTED");
          }
        });
      });
    }
  };

  turnOffCamera = () => {
    // Cancel recovery + stop watchdog before stopping tracks so that
    // onTrackEnded / onTrackMuted know this is intentional
    this._cancelRecovery();
    this.cameraActive = false;

    setTimeout(() => {
      for (var videos of this.listOfMediaTracks) {
        var videoTracks = videos.getVideoTracks()[0];
        if (videoTracks) {
          videoTracks.removeEventListener('ended', this.onTrackEnded);
          videoTracks.removeEventListener('mute', this.onTrackMuted);
          videoTracks.stop();
        }
      }

      try {
        if (window.destroyOwnedResources) {
          // window.destroyOwnedResources();
        }
      } catch (e) {
        console.log(e);
      }

    }, 1000);
  };

  closeStream = (noHideOD) => {
    console.log("Close...");
    this.repeatedDetection = false;
    document.body.classList = [];

    // Cancel recovery + stop watchdog BEFORE setTimeout so handlers
    // know this is intentional and don't re-trigger recovery
    this._cancelRecovery();
    this.cameraActive = false;

    setTimeout(() => {
      try {
        if (this.localStream) {
          this.localStream.getVideoTracks().forEach(track => {
            track.removeEventListener('ended', this.onTrackEnded);
            track.removeEventListener('mute', this.onTrackMuted);
            track.stop();
          });
        }

        if (document.querySelector("#agora_ondemand_local video")) {
          const srcObject = document.querySelector("#agora_ondemand_local video").srcObject;
          if (srcObject) {
            srcObject.getVideoTracks().forEach(track => {
              track.removeEventListener('ended', this.onTrackEnded);
              track.removeEventListener('mute', this.onTrackMuted);
              track.stop();
            });
          }
        }
      } catch (e) {
        console.log("stop error", e);
      }

      if (!noHideOD) {
        document.querySelector("#player_ondemand").innerHTML = "";
      }
    }, 1000);

    setTimeout(() => {
      document.querySelector("#agora_ondemand_local").innerHTML = "";
    }, 500);
  };

  getMediaPipePoints = (returnFrame) => {
    // Get user camera

    if (document.querySelector("#agora_ondemand_local video")) {
      if (returnFrame && window.callback_frame) {
        var canvas = document.createElement("canvas");
        canvas.width = this.useWidth / 2;
        canvas.height = this.useHeight / 2;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(document.querySelector("#agora_ondemand_local video"), 0, 0, this.useWidth / 2, this.useHeight / 2);

        var lastFrame = canvas.toDataURL();
        window.callback_frame(JSON.stringify([lastFrame, new Date().toISOString(), returnFrame]));
      }

      if (this.isIPhoneSafari()) {
        this.stretchToFill();
      }

      this.mediaPipePose.getPose(document.querySelector("#agora_ondemand_local video"), (poseLandmarks, poseLandmarksW) => {
        if (window.callback_MP) {
          this.updateStickManInternally(poseLandmarks);
          window.callback_MP(JSON.stringify(poseLandmarks));
        }

        /* if (window.callback_MPW) {
          window.callback_MPW(JSON.stringify([{ screen: poseLandmarks, world: poseLandmarksW }]));
        } */
      });

      //Check WebGL support
      /*      if(!window.WebGLRenderingContext){
         console.log("WebGL is NOT supported!");
         window.recieveSupportMessage();
     }    */
      /*       canvas.addEventListener('webglcontextlost', function(event){
        //handle context loss here
        event.preventDefault();
      },false); 
        
*/
    }
  };

  stretchToFill = () => {
    const thisVideo = document.querySelector("#agora_ondemand_local video");
    if (!thisVideo) return;
    const vw = thisVideo.videoWidth;
    const vh = thisVideo.videoHeight;
    if (!vw || !vh) return;

    thisVideo.style.cssText = '';
    // Lock layout box to intrinsic pixels so scale math is precise.
    thisVideo.style.width = vw + "px";
    thisVideo.style.height = vh + "px";

    const sx = window.innerWidth / vw;
    const sy = window.innerHeight / vh;

    // Center then stretch in BOTH axes
    thisVideo.style.transform = `translate(-50%, -50%) scale(${sx}, ${sy}) rotateY(180deg)`;

    document.querySelector("#agora_ondemand_local").classList.add("safariRotation");
    this._lastCameraMode = 'stretch';
  };

  isIPhoneSafari = () => {
    const ua = window.navigator.userAgent;

    // 1. Must be an iPhone (not iPad or Mac)
    const isIPhone = /iPhone/i.test(ua);
    const isIPad = /iPad/i.test(ua);
    const isMac = /Macintosh/i.test(ua) && "ontouchend" in document;

    // 2. Must be Safari (not Chrome, Firefox, Edge, or WebView)
    const isSafari =
      /Safari/i.test(ua) &&
      !/CriOS/i.test(ua) && // Chrome on iOS
      !/FxiOS/i.test(ua) && // Firefox on iOS
      !/EdgiOS/i.test(ua) && // Edge on iOS
      !/OPiOS/i.test(ua) && // Opera on iOS
      !/DuckDuckGo/i.test(ua); // DDG browser

    return (isIPhone || isMac) && isSafari && !isIPad;
  };

  startVirtualFullDetection = (doFullHide) => {
    if (this.repeatedDetection) {
      return;
    }
    this.doHiding = false;
    if (doFullHide) {
      if (window["electron"]) {
        document.body.classList = ["fullDetectionRunning"];
      } else {
        document.body.classList = ["fullDetectionRunningWeb"];
      }
      this.hideMasks = [];
      this.listStickMan = [];
      this.doHiding = true;
    }

    this.repeatedDetection = true;
    window.onresize = () => {
      this.flutterCanvas = false;
      this.drawContext = false;
      this.drawContext1 = false;

      if (this.isIPhoneSafari()) {
        this.stretchToFill();
      }
    };
    this.loopVirtualFullDetection();
  };

  canvasCapture = () => {
    /* if (document.querySelector("#agora_ondemand_local video")) {
      var canvas = document.createElement("canvas");
      canvas.width = this.useWidth / 2;
      canvas.height = this.useHeight / 2;
      var objContext = canvas.getContext("2d");
      objContext.drawImage(document.querySelector("#agora_ondemand_local video"), 0, 0, this.useWidth / 2, this.useHeight / 2);
      var pixelBuff = objContext.getImageData(0, 0, this.useWidth / 2, this.useHeight / 2);
      var uint8ClampedArray = pixelBuff.data;
      var arrayBuffer = uint8ClampedArray.buffer;

      if (arrayBuffer != null && window.checkScreenContrast) {
        window.checkScreenContrast(arrayBuffer);
      }
    } */
  };

  takeScreenshot = () => {
    if (document.querySelector("#agora_ondemand_local video")) {
      var canvas = document.createElement("canvas");
      canvas.width = 600;
      canvas.height = 250;
      var objContext = canvas.getContext("2d");
      objContext.drawImage(document.querySelector("#agora_ondemand_local video"), 0, 0, 600, 250);

      var img = canvas.toDataURL();
      img = img.split(",")[1];

      if (img != null && window.recieveScreenshot) {
        window.recieveScreenshot(img);
      }
    }
  };

  loopVirtualFullDetection = () => {
    if (this.repeatedDetection) {
      var vidElm = document.querySelector("#agora_ondemand_local video");
      // CRITICAL: Check if video element exists and is ready before accessing properties
      // This prevents "Cannot read properties of null" errors during widget transitions
      if (!vidElm || !vidElm.videoWidth || !vidElm.videoHeight) {
        // Video element not ready yet - retry after short delay
        if (this.repeatedDetection) {
          if (window["electron"]) {
            requestAnimationFrame(this.loopVirtualFullDetection);
          } else if (window["isDesktopWeb"]) {
            setTimeout(this.loopVirtualFullDetection, 40);
          } else if (window.isIOSSafari) {
            setTimeout(this.loopVirtualFullDetection, 150);
          } else {
            setTimeout(this.loopVirtualFullDetection, 100);
          }
        }
        return;
      }
      if (this.drawContext1) {
        this.drawContext1.drawImage(vidElm, 0, 0, vidElm.videoWidth, vidElm.videoHeight, 0, 0, this.useWidth, this.useHeight);
      }
      this.mediaPipePose.getPose(vidElm, (poseLandmarks, poseLandmarksW) => {
        // CRITICAL: Validate poseLandmarks before calling callback to prevent $0 errors
        if (window.callback_MP && this.repeatedDetection && poseLandmarks) {
          try {
            this.updateStickManInternally(poseLandmarks);
            window.callback_MP(JSON.stringify(poseLandmarks));
          } catch (e) {
            console.warn("Error in callback_MP:", e);
          }

          if (this.doHiding) {
            this.drawCanvasFromFlutter();
          }
        }

        /*
        if (window.callback_MPW && window['electron'] ) {
          window.callback_MPW(JSON.stringify([{ screen: poseLandmarks, world: poseLandmarksW }]));
        }*/

        if (this.repeatedDetection) {
          if (window["electron"]) {
            requestAnimationFrame(this.loopVirtualFullDetection);
          } else if (window["isDesktopWeb"]) {
            setTimeout(this.loopVirtualFullDetection, 40);
          } else if (window.isIOSSafari) {
            setTimeout(this.loopVirtualFullDetection, 150);
          } else {
            setTimeout(this.loopVirtualFullDetection, 100);
          }
        }
      });
    }
  };

  stopVirtualFullDetection = () => {
    document.body.classList = [];
    this.repeatedDetection = false;
    //if ( window.closePoseAllReload ) { window.closePoseAllReload(); }
  };

  updateNewMP = (objMP) => {
    this.mediaPipePose = new mediaPipePose();
  };

  drawCanvasFromFlutter = () => {
    if (!this.flutterCanvas || !this.drawContext || !this.drawContext1) {
      this.flutterCanvas = document.querySelector("flt-glass-pane").shadowRoot.querySelector("canvas");
      this.drawContext = document.querySelector("#canvas-flutter").getContext("2d");
      this.drawContext1 = document.querySelector("#canvas-user").getContext("2d");
    }

    if (this.flutterCanvas && this.drawContext) {
      var offsetFlutter = this.flutterCanvas.style.transform && this.flutterCanvas.style.transform.split(", ").length > 1 && this.flutterCanvas.style.transform.split(", ")[1].split("px").length > 1 ? this.flutterCanvas.style.transform.split(", ")[1].split("px")[0] : 0;

      var canvasSizeUp = window.innerWidth / parseInt(this.flutterCanvas.style.width);
      var canvasSizeUp1 = window.innerHeight / parseInt(this.flutterCanvas.style.height);
      var canvasSizeUp2 = parseInt(this.flutterCanvas.style.width) / this.flutterCanvas.width;

      this.drawContext.clearRect(0, 0, this.useWidth, this.useHeight);

      if (!window["electron"]) {
        if (this.sizeSetupOnce == false) {
          this.sizeSetupOnce = true;

          document.querySelector("#canvas-user").width = this.useWidth;
          document.querySelector("#canvas-user").height = this.useHeight;
          document.querySelector("#canvas-flutter").width = this.useWidth;
          document.querySelector("#canvas-flutter").height = this.useHeight;

          // document.querySelector("#canvas-user").style.display = 'none';
        }
      } else {
        this.drawContext.drawImage(this.flutterCanvas, 0, (parseInt(offsetFlutter) / canvasSizeUp2) * -1, this.flutterCanvas.width * canvasSizeUp, this.flutterCanvas.height * canvasSizeUp1, 0, 0, this.useWidth, this.useHeight);
      }

      if (window["electron"] && window["poseSegmentationMask"]) {
        this.simpleCtx.clearRect(0, 0, this.useWidth, this.useHeight);
        this.hideMasks.forEach((itm) => {
          if (itm["x1"] > itm["x2"]) {
            var x1 = itm["x1"];
            itm["x1"] = itm["x2"];
            itm["x2"] = x1;
          }

          var pRec = {
            x1: itm["x1"] - 10,
            y1: itm["y1ret"] ? itm["y1ret"] : itm["y1"] - 10,
            w: itm["x2"] - itm["x1"] + 40,
            h: (itm["y2ret"] ? itm["y2ret"] : itm["y2"]) - (itm["y1ret"] ? itm["y1ret"] : itm["y1"]) + 40,
          };

          var screenOffsetX = this.useWidth / window.innerWidth;
          var screenOffsetY = this.useHeight / window.innerHeight;

          this.simpleCtx.fillRect(pRec["x1"] * screenOffsetX, pRec["y1"] * screenOffsetY, pRec["w"] * screenOffsetX, pRec["h"] * screenOffsetY);
        });

        this.simpleCtx.save();
        this.simpleCtx.globalCompositeOperation = "destination-in";
        this.simpleCtx.translate(this.useWidth, 0);
        this.simpleCtx.scale(-1, 1);
        this.simpleCtx.drawImage(window["poseSegmentationMask"], 0, 0, this.useWidth, this.useHeight);
        this.simpleCtx.globalCompositeOperation = "source-over";
        this.simpleCtx.restore();

        this.drawContext.save();
        this.drawContext.globalCompositeOperation = "destination-out";
        this.drawContext.drawImage(this.simpleCanvas, 0, 0, this.useWidth, this.useHeight);
        this.drawContext.globalCompositeOperation = "source-over";
        this.drawContext.restore();
      }

      if (this.listStickMan && this.listStickMan.length > 0) {
        this.drawContext.beginPath();
        this.drawContext.strokeStyle = "rgba(0, 209, 209, 0.7)";
        this.drawContext.lineWidth = 7;
        this.drawContext.lineCap = "round";

        // before drawing this frame
        const v = document.querySelector("#agora_ondemand_local video");
        const c = this.drawContext.canvas;

        const vRect = v.getBoundingClientRect(); // video's on-screen box (CSS px)
        const cRect = c.getBoundingClientRect(); // canvas' on-screen box (CSS px)

        // canvas CSS→pixel multipliers (handles devicePixelRatio)
        const mx = c.width / cRect.width;
        const my = c.height / cRect.height;

        // offset from canvas origin to video origin, in canvas pixels
        const ox = (vRect.left - cRect.left) * mx;
        const oy = (vRect.top - cRect.top) * my;

        // --- lines ---
        this.drawContext.beginPath();
        this.drawContext.fillStyle = "rgba(7, 255, 255, 1)";
        for (const itm of this.listStickMan) {
          const x1 = ox + itm["x1"] * vRect.width * mx; // no mirror
          const y1 = oy + itm["y1"] * vRect.height * my;
          const x2 = ox + itm["x2"] * vRect.width * mx;
          const y2 = oy + itm["y2"] * vRect.height * my;

          this.drawContext.moveTo(x1, y1);
          this.drawContext.lineTo(x2, y2);
        }
        this.drawContext.stroke();

        // --- dots ---
        for (const itm of this.listStickMan) {
          const x1 = ox + itm["x1"] * vRect.width * mx;
          const y1 = oy + itm["y1"] * vRect.height * my;
          const x2 = ox + itm["x2"] * vRect.width * mx;
          const y2 = oy + itm["y2"] * vRect.height * my;

          this.drawContext.beginPath();
          this.drawContext.fillStyle = "rgba(7, 255, 255, 1)";
          this.drawContext.arc(x1, y1, 6, 0, 2 * Math.PI);
          this.drawContext.fill();

          this.drawContext.beginPath();
          this.drawContext.fillStyle = "rgba(7, 255, 255, 1)";
          this.drawContext.arc(x2, y2, 6, 0, 2 * Math.PI);
          this.drawContext.fill();
        }
      }
    }
  };

  updateMasksArray = (listMask) => {
    this.hideMasks = JSON.parse(listMask);
    console.log(this.hideMasks);
  };

  updateStickManArray = (listStickMan) => {
    this.listStickMan = JSON.parse(listStickMan);
    console.log("STICK MAN", this.listStickMan);
  };

  updateStickManInternally = (mplist) => {
    if (!mplist || mplist.length < 30 || !mplist[0]['x']) { return; }

    // Helper to safely extract x/y as number
    const getCoord = (idx, key) => Number(mplist?.[idx]?.[key] ?? 0.0);

    // Left arm
    const lShX = getCoord(12, 'x');
    const lShY = getCoord(12, 'y');

    const lElbX = getCoord(14, 'x');
    const lElbY = getCoord(14, 'y');

    const lWrX = getCoord(16, 'x');
    const lWrY = getCoord(16, 'y');

    // Right arm
    const rShX = getCoord(11, 'x');
    const rShY = getCoord(11, 'y');

    const rElbX = getCoord(13, 'x');
    const rElbY = getCoord(13, 'y');

    const rWrX = getCoord(15, 'x');
    const rWrY = getCoord(15, 'y');

    // Hips
    const rHipX = getCoord(23, 'x');
    const rHipY = getCoord(23, 'y');

    const lHipX = getCoord(24, 'x');
    const lHipY = getCoord(24, 'y');

    // Knees
    const lKneeX = getCoord(26, 'x');
    const lKneeY = getCoord(26, 'y');

    const rKneeX = getCoord(25, 'x');
    const rKneeY = getCoord(25, 'y');

    // Ankles
    const lAnkX = getCoord(28, 'x');
    const lAnkY = getCoord(28, 'y');

    const rAnkX = getCoord(27, 'x');
    const rAnkY = getCoord(27, 'y');

    // Midpoints (normalized)
    const midHipX = (lHipX + rHipX) / 2;
    const midHipY = (lHipY + rHipY) / 2;
    const midShoulderX = (lShX + rShX) / 2;
    const midShoulderY = (lShY + rShY) / 2;

    // Stickman lines (already normalized 0..1)
    const stickManLines = [
      { x1: lShX, y1: lShY, x2: rShX, y2: rShY },
      { x1: rHipX, y1: rHipY, x2: lHipX, y2: lHipY },

      { x1: lShX, y1: lShY, x2: lElbX, y2: lElbY },
      { x1: lElbX, y1: lElbY, x2: lWrX, y2: lWrY },

      { x1: rShX, y1: rShY, x2: rElbX, y2: rElbY },
      { x1: rElbX, y1: rElbY, x2: rWrX, y2: rWrY },

      { x1: rHipX, y1: rHipY, x2: rKneeX, y2: rKneeY },
      { x1: rKneeX, y1: rKneeY, x2: rAnkX, y2: rAnkY },

      { x1: lHipX, y1: lHipY, x2: lKneeX, y2: lKneeY },
      { x1: lKneeX, y1: lKneeY, x2: lAnkX, y2: lAnkY },

      { x1: midShoulderX, y1: midShoulderY, x2: midHipX, y2: midHipY }
    ];

    this.listStickMan = stickManLines;
  }


  getCurrentVideoDevice = () => {
    return JSON.stringify(this.getLastPickedCamera());
  };

  getCurrentSpeakerDevice = () => {
    return JSON.stringify(this.getLastPickedSpeaker());
  };

  getLastPickedSpeaker = () => {
    var pickedId = localStorage.getItem("virtual_speaker_selected");

    if (!pickedId) {
      return this.listOfSpeakers[0] ? this.listOfSpeakers[0] : null;
    }

    var returnSpe = this.listOfSpeakers[0];

    var i = 0;
    this.listOfSpeakers.forEach((spe) => {
      if (spe.deviceId === pickedId) {
        returnSpe = spe;
      }
      i++;
    });

    localStorage.setItem("virtual_speaker_selected", returnSpe && returnSpe.deviceId ? returnSpe.deviceId : "");

    return returnSpe;
  };

  cameraSetupStart = () => {
    window.allowLockVisibility = true
    console.log("cameraSetupStart");
    const isGsaFlow = Boolean(localStorage.getItem("loadSelf"));
    const wasChatOpenAtSelection =
      isGsaFlow &&
      typeof window.MyraInteraction.isChatOpen === "function" &&
      window.MyraInteraction.isChatOpen();
    if (window.MyraInteraction) {
      window.MyraInteraction.onScreenEnter("intro_ar");
      // if (
      //   wasChatOpenAtSelection &&
      //   typeof window.MyraInteraction.openChat === "function"
      // ) {
      //   window.MyraInteraction.openChat();
      // }
    }
    // setTimeout(async () => {
    //   if (window.wakeLockManager) {
    //     await window.wakeLockManager.acquire();
    //   }
    // }, 100);
    setTimeout(() => {
      document.querySelector("html").classList = [];

      const flutterRoot = document.getElementById("OnDemandPlayingRoot");
      if (flutterRoot) flutterRoot.style.display = "block";

      const currentAssessmentRoot = document.getElementById("assesmentDiv");
      if (currentAssessmentRoot) currentAssessmentRoot.style.display = "none";

      if (window.callbackOpenFlutter) {
        window.callbackOpenFlutter();
      }

      if (document.querySelector(".rom-test-start-button")) {
        document.querySelector(".rom-test-start-button").innerHTML = "Start Movement Test";
      }
    }, 100);
  };

  showPreparationHost = () => {
    this.setCameraChoiceSilentFlow();

    setTimeout(() => {
      document.querySelector("html").classList = [];

      const flutterRoot = document.getElementById("OnDemandPlayingRoot");
      if (flutterRoot) flutterRoot.style.display = "block";

      const currentAssessmentRoot = document.getElementById("assesmentDiv");
      if (currentAssessmentRoot) currentAssessmentRoot.style.display = "none";
    }, 100);
  };

  setCameraChoiceSilentFlow = () => {

    // stop audio before starting silent flow
    if (window.stopAudio) {
      window.stopAudio();
    }
    window.currentFlow = "flow_silent";
    if (window.VoiceService) {
      window.VoiceService._currentFlow = "flow_silent";
    }
    // setup global virtual listener to listen to myra commands
    if (window.mayraCode && window.mayraCode.setupGlobalVirtualListener) {
      window.mayraCode.setupGlobalVirtualListener();
    }
    if (window.mayraCode) {
      window.mayraCode.disableCallback();
      window.mayraCode.startFlow("flow_silent");
    }
    this.defineListenCommands();
  };


  prepareAppJurneyPayload = (payload) => {
    console.log('GOT PAYLOAD', payload);

    if (window.VoiceService && window.VoiceService.sendMidJourneyData && payload) {
      let payloadObject = JSON.parse(payload);
      console.log('GOT PAYLOAD OBJ', payloadObject);

      if (payloadObject) {
        window.VoiceService.sendMidJourneyData(payload);
        window.cameraPayload = payload;
      }
    }
  };

  cameraSetupShow = () => {
    document.body.classList = ["cameraSetupScreen"];

    if (window.mayraCode && window.mayraCode.setIsVisible) {
      window.mayraCode.setIsVisible(true);
    }

    setTimeout(() => {
      document.querySelector("html").classList = [];

      const flutterRoot = document.getElementById("OnDemandPlayingRoot");
      if (flutterRoot) flutterRoot.style.display = "block";

      const currentAssessmentRoot = document.getElementById("assesmentDiv");
      if (currentAssessmentRoot) currentAssessmentRoot.style.display = "none";
    }, 100);

    let flowStarted = false;
    let fallbackTimer = null;
    const isGsaFlow = Boolean(localStorage.getItem("loadSelf"));
    const wasChatOpen =
      isGsaFlow &&
      typeof window.MyraInteraction.isChatOpen === "function" &&
      window.MyraInteraction.isChatOpen();

    console.log("wasChatOpen isGsaFlow isChatOpen", wasChatOpen, isGsaFlow, window.MyraInteraction.isChatOpen());

    const startCameraPermissionFlow = () => {
      if (flowStarted) return;
      flowStarted = true;


      if (window?.cameraPayload) {
        window.VoiceService.sendMidJourneyData(window?.cameraPayload);
      }
      if (window.MyraInteraction) {
        window.MyraInteraction.onScreenEnter("movement_test_1");
        // if (
        //   wasChatOpen &&
        //   typeof window.MyraInteraction.openChat === "function"
        // ) {
        //   window.MyraInteraction.openChat();
        // }
      }

      window.mayraCode.startFlow(
        "flow_camera_screen",
        "camera_permission"
      );

      this.defineListenCommands();
    };

    const startWithoutPermissionFlow = () => {
      if (flowStarted) return;
      flowStarted = true;

      if (window?.cameraPayload) {
        window.VoiceService.sendMidJourneyData(window?.cameraPayload);
      }
      if (window.MyraInteraction) {
        window.MyraInteraction.onScreenEnter("movement_test_1");
        // if (
        //   wasChatOpen &&
        //   typeof window.MyraInteraction.openChat === "function"
        // ) {
        //   window.MyraInteraction.openChat();
        // }
      }

      window.mayraCode.startFlow(
        "flow_camera_screen",
        "without_camera_permission"
      );

      this.defineListenCommands();
    };

    if (window.mayraCode) {
      window.mayraCode.setOnMicEnabled(null);
      window.mayraCode.setupGlobalVirtualListener();
      window.mayraCode.disableCallback();

      // FAST PATH — permissions API
      if (navigator.permissions?.query) {
        navigator.permissions
          .query({ name: "camera" })
          .then((res) => {
            if (res.state === "granted") {
              startCameraPermissionFlow();
            } else {
              startWithoutPermissionFlow();
            }
          })
          .catch(() => {
            startWithoutPermissionFlow();
          });
      }

      // FALLBACK — safety net (4s)
      fallbackTimer = setTimeout(() => {
        startWithoutPermissionFlow();
      }, 4000);
    }

    this.getUserPermission(this.getLastPickedCamera(), false, (res) => {
      console.log("Camera picked");
      this.cameraActive = true;

      if (fallbackTimer) {
        clearTimeout(fallbackTimer);
      }

      // If permission arrives before any flow decision
      if (!flowStarted && window.mayraCode) {
        startCameraPermissionFlow();
      }
    });
  };

  defineListenCommands = () => {
    window.currentCommandsAudio = {
      START_TEST: () => {
        window.mayraCode.doSay("Great! Let's start the test.", () => {
          document.body.classList.remove("videoplay-expanded");
          if (window?.movementTestPayload) {
            window.VoiceService.sendMidJourneyData(window?.movementTestPayload);
          }
          if (window.MyraInteraction) {
            window.MyraInteraction.onScreenEnter("movement_test_1");
          }
          setTimeout(() => {
            if (window.tipsClickNext) {
              window.tipsClickNext();
              window.mayraCode.disableCallback();
              window.mayraCode.startFlow("start_silent");
            }
          }, 2000);
        });
      },
      PROCEED_WITHOUT_CAMERA: () => {
        window.mayraCode.doSay("Sure! You can continue without the camera, camera is optional.", () => {
          document.body.classList.remove("videoplay-expanded");
          if (window?.movementTestPayload) {
            window.VoiceService.sendMidJourneyData(window?.movementTestPayload);
          }
          if (window.proceedNoCamera) { window.proceedNoCamera(); }
        });
      },
      PROCEED_WITHOUT_CAMERA: () => {
        window.mayraCode.doSay("Sure! You can continue without the camera, camera is optional.", () => {
          document.body.classList.remove("videoplay-expanded");
          if (window.movementTestPayload) {
            window.VoiceService.sendMidJourneyData(window.movementTestPayload);
          }
          if (window.proceedNoCamera) { window.proceedNoCamera(); }
        });
      },
      MOVE_ON: () => {
        console.log("MOVE_ON");
        this.handleContinue();
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        console.log("ANSWER_MidJourneyFlow_QUESTION", value, speech, intent);
        if (intent === "continue_command") {
          this.handleContinue();
        }
      },
      EXPAND_VIDEO: () => {
        window.mayraCode.doSay("Sure! I'll expand the video for you.", () => {
          document.body.classList.add("videoplay-expanded");
        });
      },
      EXPAND_CAMERA: () => {
        window.mayraCode.doSay("Sure! I'll expand the camera for you.", () => {
          document.body.classList.add("videoplay-expanded");
        });
      },
    };
  }

  handleContinue = () => {
    if (window.MyraInteraction && typeof window.MyraInteraction.onScreenEnter === "function") {
      window.MyraInteraction.onScreenEnter("movement_test_1");
    }
    window.mayraCode.doSay("Great! Let's move on to the next step.", () => {
      document.body.classList.remove("videoplay-expanded");
      setTimeout(() => {
        if (window.tipsClickNext) {
          window.tipsClickNext();
          window.mayraCode.disableCallback();
          window.mayraCode.startFlow("start_silent");
        }
      }, 2000);
    });
  }

  startMyraClass = (resumeStart) => {
    if (window.mayraCode && window.mayraCode.setOnMicEnabled && !window.mayraCode.isEnabled) {

      window.mayraCode.setOnMicEnabled(null);
      window.mayraCode.setOnMicEnabled((enabledBefore) => {
        const isResume = resumeStart == 'resume';
        console.log("Started Myra", resumeStart);
        window.mayraCode.setOnMicEnabled(null);

        window.mayraCode.setupGlobalVirtualListener();
        window.mayraCode.disableCallback();
        window.mayraCode.startFlow("start_silent");

        setTimeout(() => {
          window.mayraCode.doSay("{name}. | Nice to have you back! When you're ready, press " + (isResume ? 'Re-zoom' : 'Start') + " and I'll be ready to guide you.", () => {
            window.mayraCode.setIsVisible(false);
          });
        }, 2000);
      });
      window.mayraCode.handleMicClick(true, true);
    }
  };

  startMyraClassSilent = () => {
    window.mayraCode.setOnMicEnabled(null);
    if (window.mayraCode && window.mayraCode.setOnMicEnabled && !window.mayraCode.isEnabled) {
      window.mayraCode.setOnMicEnabled((enabledBefore) => {
        console.log("Started Myra");
        window.mayraCode.disableCallback();
        window.mayraCode.startFlow("start_silent");
        window.mayraCode.setIsVisible(false);
      });
      window.mayraCode.handleMicClick(true, true);
    }
  };

  isMyraActive = () => {
    if (window.mayraCode && window.mayraCode.isEnabled) {
      return "yes";
    }

    return "no";
  };

  cameraSetupHide = () => {
    document.body.classList = [];
    this.closeStream();
    document.querySelector("#agora_ondemand_local").classList.remove("safariRotation");
  };

  cameraSetupHideCamera = () => {
    document.body.classList = [];
    if (this.isIPhoneSafari()) {
      this.stretchToFill();
    }
    //this.closeStream(true);
  };

  setVideoDevice = (deviceId) => {
    deviceId = Object.values(deviceId)[0] ? Object.values(deviceId)[0][0] : "";
    var returnCam = this.listOfCameras[0];

    var i = 0;
    this.listOfCameras.forEach((cam) => {
      if (cam.deviceId === deviceId) {
        returnCam = cam;
        this.currentCameraIndex = i;
      }
      i++;
    });

    localStorage.setItem("virtual_camera_selected", returnCam && returnCam.deviceId ? returnCam.deviceId : "");

    // Cancel recovery + watchdog before switching device
    this._cancelRecovery();

    // Set cameraActive = false BEFORE stopping tracks so onTrackEnded
    // knows this is intentional and does not trigger recovery
    try {
      if (this.localStream) {
        this.localStream.getVideoTracks().forEach(track => {
          track.removeEventListener('ended', this.onTrackEnded);
          track.removeEventListener('mute', this.onTrackMuted);
        });
        this.localStream.getVideoTracks()[0].stop();
        this.cameraActive = false;
      }
      if (document.querySelector("#agora_ondemand_local video")) {
        const srcObject = document.querySelector("#agora_ondemand_local video").srcObject;
        if (srcObject) {
          srcObject.getVideoTracks().forEach(track => {
            track.removeEventListener('ended', this.onTrackEnded);
            track.removeEventListener('mute', this.onTrackMuted);
            track.stop();
          });
        }
      }
    } catch (e) {
      console.log("stop error", e);
    }

    console.log('PICKED', returnCam);

    this.getUserPermission(returnCam, false, (res) => {
      if (res) {
        console.log("Camera changed");
        this.cameraActive = true;
        if (window.cameraIsOn) { window.cameraIsOn(); }
        if (window.doKeepVideoPlay) window.doKeepVideoPlay();
      } else {
        console.log("Camera REJECTED");
        // Ask for permission
      }
    });
  };

  setSpeakerDevice = (deviceId) => {
    deviceId = Object.values(deviceId)[0] ? Object.values(deviceId)[0][0] : "";

    var returnSpeaker = this.listOfSpeakers[0];

    this.listOfSpeakers.forEach((spe) => {
      if (spe.deviceId === deviceId) {
        returnSpeaker = spe;
      }
    });

    localStorage.setItem("virtual_speaker_selected", returnSpeaker && returnSpeaker.deviceId ? returnSpeaker.deviceId : "");

    console.log("selll", returnSpeaker);
  };

  getAppVersion = () => {
    var allInfo = window.navigator.appVersion;
    var version = allInfo.split("VirdioHealth/");
    var splitVersion = version[1].split(".");
    var p = splitVersion[0] + "." + splitVersion[1] + "." + splitVersion[2];
    var splitVersion2 = p.split(" ");
    var formattedVersion = splitVersion2[0];

    return formattedVersion.toString();
  };

  getPlatform = () => {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
      macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
      windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
      iosPlatforms = ["iPhone", "iPad", "iPod"],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = "Mac OS";
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = "iOS";
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = "Windows";
    } else if (/Android/.test(userAgent)) {
      os = "Android";
    } else if (/Linux/.test(platform)) {
      os = "Linux";
    }

    return os;
  };

  saveToJSONFile = (filename, text) => {
    if (window["fsFile"] && !window["failedWrite"]) {
      try {
        var dateStr = new Date().toISOString().split("T")[0];
        window["fsFile"].writeFileSync(window["documentsPath"] + "/virdiovirtual/" + dateStr + "_" + filename, text + "\n", { flag: "a+" });
      } catch (e) {
        window["failedWrite"] = true;
        console.log("Failed to save the file!");
      }
    }
  };

  restartFlutterTransform = () => {
    if (!this.flutterCanvas) {
      this.flutterCanvas = document.querySelector("flt-glass-pane").shadowRoot.querySelector("canvas");
    }

    var offsetFlutter = this.flutterCanvas.style.transform && this.flutterCanvas.style.transform.split(", ").length > 1 && this.flutterCanvas.style.transform.split(", ")[1].split("px").length > 1 ? this.flutterCanvas.style.transform.split(", ")[1].split("px")[0] : 0;
    this.flutterCanvas.style.marginTop = parseInt(offsetFlutter) * -1 + "px";

    window.onresize = () => {
      this.flutterCanvas = false;
      this.drawContext = false;
      this.drawContext1 = false;
      this.restartFlutterTransform();
    };
  };

  checkIsSelf = () => {
    console.log("self called");
    window.loadedSelfCorrectly = 1;

    if (!!localStorage.getItem("loadSelf") && window.loadedROM) {
      window.loadedSelfCorrectly = 2;
      return JSON.stringify(window.loadedROM);
    }
    console.log("self no");
    return "no";
  };

  getSelfLevel = () => {
    return localStorage.getItem("loadSelf") ? localStorage.getItem("loadSelf") : "";
  };

  moveAfterAssesment = () => {
    if (!localStorage.getItem("loadSelf")) {
      return "no";
    }

    if (window.blockNextSelfCall) {
      console.warn('Called too soon');
      return "no";
    }

    console.log('---moveAfterAssesment');

    this.stopStartAudio();
    this.stopLightAudio();

    document.querySelector("html").classList = ["wait-flutter"];
    document.getElementById("assesmentDiv").style.display = "block";
    document.getElementById("OnDemandPlayingRoot").style.display = "none";

    window.allowLockVisibility = false;
    // if (window.wakeLockManager?.isActive) {
    //   window.wakeLockManager.release();
    // }

    if (window.doNextLocation) {
      // Stop all audio/video before navigating to symptoms screen
      if (window.stopAudio) {
        window.stopAudio();
      }

      // Stop all video elements
      const allVideos = document.querySelectorAll("video");
      allVideos.forEach((video) => {
        try {
          video.pause();
          video.currentTime = 0;
          console.log("Paused video element before symptoms screen:", video.id || video.src);
        } catch (err) {
          console.warn("Failed to pause video:", err);
        }
      });
      if (window.VoiceService) {
        window.VoiceService._pcmBuffer = null;
        window.VoiceService._pendingAudioUrls = [];
        window.VoiceService._awaitingPcmFinish = false;
        window.VoiceService._currentFlow = null;
      }

      if (window.audioPlayer) {
        try {
          if (window.audioPlayer.ttsPcmAbort) {
            window.audioPlayer.ttsPcmAbort();
          }
          if (window.audioPlayer.stop) {
            window.audioPlayer.stop();
          }
          if (window.audioPlayer.pcm) {
            window.audioPlayer.pcm.bufferTime = 0;
            window.audioPlayer.pcm.queuedSamples = 0;
            window.audioPlayer.pcm.active = false;

            if (window.audioPlayer.pcm.clearBuffer) {
              window.audioPlayer.pcm.clearBuffer();
            }
          }
        } catch (e) {
          console.warn("Error stopping audio player:", e);
        }
      }
      if (window.stopAudio) {
        try {
          window.stopAudio();
          console.log("Global audio system stopped");
        } catch (e) {
          console.warn("Failed to stop global audio:", e);
        }
      }
      window.currentCommandsAudio = {};
      window.currentFlow = null;

      if (window.mayraCode) {
        try {
          window.mayraCode.forceStop();
          window.mayraCode.disableCallback();
        } catch (e) {
          console.warn("Error stopping mayraCode:", e);
        }
      }
      document.body.classList.remove("videoplay-expanded");
      if (window.VoiceService) {
        window.VoiceService.resetAssembly()
      }
      const isV2 = localStorage.getItem("isV2") === "true";
      if (localStorage.getItem("runStep") == "2") {
        window.VoiceService._currentFlow = "flow_symptom"
        window.currentFlow = "flow_symptom"
        if (window.MyraInteraction) {
          window.MyraInteraction.onScreenEnter("symptom2");
        }
        if (isV2) {
          window.doNextLocation.push()
        } else {
          window.doNextLocation.replace("/feedback-2");
        }
        setTimeout(() => {
          window.turnOffCamera();
          document.body.style = "";
        }, 3000);
      } else {
		  
		try {
		  if (window.gtag) {
			window.gtag("event", "conversion", { send_to: "AW-18002481001/LAGZCLqhn6QcEOmeoIhD", "value": 1.0, "currency": "USD" });
		  }
		} catch (e) {
		  console.warn(e);
		}
		
        window.movementTestPayload = null;
        window.VoiceService._currentFlow = "flow_rpe"
        window.currentFlow = "flow_rpe"
        if (window.MyraInteraction) {
          window.MyraInteraction.onScreenEnter("test1_rpe");
        }
        const isNoCameraFlow = localStorage.getItem("noCameraMode") === "true";
        // window.doNextLocation.replace(isNoCameraFlow ? "/self-report-questions" : "/how-challenging");


        if (isV2) {
          window.doNextLocation.push()
        } else {
          window.doNextLocation.replace(
            isNoCameraFlow ? "/self-report-questions" : "/how-challenging"
          );
        }
      }
    }

    return "yes";
  };

  moveAfterAssesmentSave = (dataInfo, dataInfo2) => {
    localStorage.setItem("dataAfterInfo", JSON.stringify(dataInfo2));
  };

  closeSelfVirtual = () => {
    document.querySelector("html").classList = ["wait-flutter"];

    console.log('---closeSelfVirtual');

    if (document.getElementById("assesmentDiv")) {
      document.getElementById("assesmentDiv").style.display = "block";
    }
    if (document.getElementById("OnDemandPlayingRoot")) {
      document.getElementById("OnDemandPlayingRoot").style.display = "none";
    }
    if (window.turnOffCamera) {
      window.turnOffCamera();
    }
    document.body.style = "";
    window.clickedOnceOpen = false;
  };

  restartSelfAsses = (passed) => {
    console.log("sent", passed);

    console.log('---restartSelfAsses');

    if (passed != "" && localStorage.getItem("runStep") == "2") {
      document.querySelector("html").classList = ["wait-flutter"];

      if (document.getElementById("assesmentDiv")) {
        document.getElementById("assesmentDiv").style.display = "block";
      }
      if (document.getElementById("OnDemandPlayingRoot")) {
        document.getElementById("OnDemandPlayingRoot").style.display = "none";
      }
      if (window.turnOffCamera) {
        window.turnOffCamera();
      }
      document.body.style = "";
      window.clickedOnceOpen = false;

      if (window.doNextLocation) {
        try {
          const assessmentData = JSON.parse(localStorage.getItem("assessmentData")) || {};
          assessmentData.symptomResponseConfirm = "WORSENED";
          localStorage.setItem("assessmentData", JSON.stringify(assessmentData));
          console.log("Auto-set 2nd symptom response to WORSENED due to skipped test");
        } catch (err) {
          console.error("Error setting auto WORSENED symptom response", err);
        }
        console.log("Stopping all media before navigation...");

        if (window.VoiceService && window.VoiceService._mediaRecorder) {
          try {
            const stream = window.VoiceService._mediaRecorder.stream;
            if (window.VoiceService._mediaRecorder.state === "recording") {
              window.VoiceService._mediaRecorder.stop();
            }
            if (stream && stream.getTracks) {
              stream.getTracks().forEach(track => {
                try {
                  track.stop();
                  track.enabled = false;
                } catch (e) {
                  console.warn("Failed to stop track:", e);
                }
              });
            }
            window.VoiceService._mediaRecorder = null;
            window.VoiceService._isListening = false;
            console.log("MediaRecorder stopped");
          } catch (e) {
            console.warn("Error stopping MediaRecorder:", e);
          }
        }
        if (window.VoiceService) {
          window.VoiceService._pcmBuffer = null;
          window.VoiceService._pendingAudioUrls = [];
          window.VoiceService._awaitingPcmFinish = false;
          window.VoiceService._currentFlow = null;
        }

        if (window.audioPlayer) {
          try {
            console.log("Stopping audio player...");
            if (window.audioPlayer.ttsPcmAbort) {
              window.audioPlayer.ttsPcmAbort();
            }
            if (window.audioPlayer.stop) {
              window.audioPlayer.stop();
            }
            if (window.audioPlayer.pcm) {
              window.audioPlayer.pcm.bufferTime = 0;
              window.audioPlayer.pcm.queuedSamples = 0;
              window.audioPlayer.pcm.active = false;
              if (window.audioPlayer.pcm.clearBuffer) {
                window.audioPlayer.pcm.clearBuffer();
              }
            }
            console.log("Audio player stopped");
          } catch (e) {
            console.warn("Error stopping audio player:", e);
          }
        }
        if (window.stopAudio) {
          try {
            window.stopAudio();
            console.log("Global audio system stopped");
          } catch (e) {
            console.warn("Failed to stop global audio:", e);
          }
        }
        console.log("Stopping all HTML5 media elements...");

        document.querySelectorAll("audio").forEach(audio => {
          try {
            audio.pause();
            audio.currentTime = 0;
            audio.src = "";
            audio.load();
          } catch (e) {
            console.warn("Failed to stop audio element:", e);
          }
        });

        document.querySelectorAll("video").forEach(video => {
          try {
            video.pause();
            video.currentTime = 0;
            video.muted = true;
            video.src = "";
            video.load();
          } catch (e) {
            console.warn("Failed to stop video element:", e);
          }
        });

        window.currentCommandsAudio = {};
        window.currentFlow = null;

        if (window.mayraCode) {
          try {
            window.mayraCode.forceStop();
            window.mayraCode.disableCallback();
          } catch (e) {
            console.warn("Error stopping mayraCode:", e);
          }
        }
        if (window?.VoiceService) {
          window?.VoiceService?.stopAllVoiceActivity()
          window?.VoiceService?.stopAgentSpeech()
        }
        document.body.classList.remove("videoplay-expanded");
        console.log("All media cleanup complete, navigating...");
        window.VoiceService._currentFlow = "flow_personalized"
        window.currentFlow = "flow_personalized"
        const isV2 = localStorage.getItem("isV2") === "true";
        setTimeout(() => {
          if (isV2) {
            window.test2WasSkipped = true;
            window.test2AnnounceSkipped = true
            window.doNextLocation.push();
          } else {
            window.test2WasSkipped = false;
            window.test2AnnounceSkipped = false
            window.doNextLocation.replace("/plan-recommendation");
          }
        }, 500);
      } else {
        console.log("NOT DEFINED CORRECTLY");
      }
    } else {
      const flutterView = document.querySelector("flutter-view");
      if (flutterView) {
        flutterView.style.display = "none";
      }
      const loader = document.getElementById("flutter-loader");
      if (loader) loader.style.display = "none";

      window.isFlutterLoaded = false;
      window.savedDeeplink = "";

      const popup = document.getElementById("restartPopup");
      if (popup) {
        popup.style.display = "flex";
        if (window.setRestartVisible) window.setRestartVisible(true);
        const okBtn = document.getElementById("restartOkBtn");
        okBtn.onclick = () => {
          popup.style.display = "none";
          localStorage.setItem('loadAfterReloadAutoHome', '1');
          window.location.replace(window.location.origin);
        };
      } else {
        localStorage.setItem('loadAfterReloadAutoHome', '1');
        window.location.replace(window.location.origin);
      }
    }
  };

  cameraBoxPosition = (pos) => {
    console.log("Got ", pos);
    pos = JSON.parse(pos);
    document.getElementById("cameraCustomRules").innerHTML = `
		body.cameraSetupScreen #agora_ondemand_local video,
		body.cameraSetupScreen #agora_ondemand_local_waiting {
		  position: absolute;
		  left: ${pos.left}px;
		  top: ${pos.top}px;
		  width: ${pos.width}px;
		  height: ${pos.height}px;
		}
  `;

    this._lastCameraMode = 'box';
    this._lastBoxPosition = pos;
  };

  loadROMExercises = async (loadTime) => {
    if (!localStorage.getItem("loadSelf")) {
      return;
    }

    try {
      const res = await fetch(this.APIURL + "/api/v1/global_configuration/getGlobalROM", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ exercise: localStorage.getItem("loadSelf"), problemArea: window.problemArea ? window.problemArea : 'LBP', subType: window.selectedSubType ? window.selectedSubType : '', changeEx: !!window.assessmentChangeExercise }),
      });

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const result = await res.json();
      console.log("---", result);

      window.loadedROM = result.responseData;

      if (loadTime == true && window.loadedSelfCorrectly == 1 && window.doCameraScreenStart) {
        window.doCameraScreenStart();
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  getWindowSize = () => {
    return window.innerHeight;
  };

  updateMyName = (newName) => {
    if (!newName) {
      return;
    }

    window.localStorage.setItem("self_name", newName);
  };

  checkCameraSetupImage = (exercise) => {
    this.checkCameraSetupImageAPI(exercise, "", false);
  };

  checkCameraSetupImageVisible = (exercise) => {
    this.checkCameraSetupImageAPI(exercise, ["lighting", "backgroundContrast", "cameraAngle", "seatingCheck"], true);
  };

  checkCameraSetupImageAPI = (exercise, sendOptions, doCallBack) => {
    const t0 = performance.now();
    this.audioSaidLight = false;
    if (document.querySelector("#agora_ondemand_local video")) {
      const videoEl = document.querySelector("#agora_ondemand_local video");
      const videoRatio = videoEl.videoWidth / videoEl.videoHeight;
      let canvasWidth = Math.min(480, this.useWidth);
      let canvasHeight = canvasWidth / videoRatio;
      if (canvasHeight > this.useHeight) {
        canvasHeight = this.useHeight;
        canvasWidth = canvasHeight * videoRatio;
      }
      const canvas = document.createElement("canvas");
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(videoEl, 0, 0, canvas.width, canvas.height);
      var img = canvas.toDataURL("image/jpeg", 0.8);
      img = img ? img.split(",")[1] : null;
      // FORCE CLEANUP
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      canvas.width = 0;
      canvas.height = 0;
      canvas.remove();
      const tCapture = performance.now();
      console.log(`[checkCameraSetupImageAPI] Image capture: ${(tCapture - t0).toFixed(1)}ms`);
      if (img != null) {
        try {
          const tFetchStart = performance.now();
          fetch(this.APIURL + "/api/v1/assessment/processimage", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ imageBase64: img, exercise: JSON.parse(exercise), checkTypes: sendOptions }),
          }).then((res) => {
            const tFetchEnd = performance.now();
            console.log(`[checkCameraSetupImageAPI] Network (fetch): ${(tFetchEnd - tFetchStart).toFixed(1)}ms`);
            res.json().then((data) => {
              const tParsed = performance.now();
              console.log(`[checkCameraSetupImageAPI] Response parse: ${(tParsed - tFetchEnd).toFixed(1)}ms`);
              // console.log(`[checkCameraSetupImageAPI] TOTAL: ${(tParsed - t0).toFixed(1)}ms`);
              console.log("API Response (processimage):", data);
              if (data?.data?.bodyPosition) {
                localStorage.setItem("bodyPosition", JSON.stringify(data.data.bodyPosition));
                console.log("bodyPosition saved to localStorage:", data.data.bodyPosition);
              }
              if (window.listenMyraStart) {
                window.listenMyraStart();
              }
              if (data.data && data.data.consolidatedFeedback && this.audioSaidLight == false) {
                window.mayraCode.doSay(data.data.consolidatedFeedback, () => { });
              } else if (this.audioSaidLight == false) {
                setTimeout(() => {
                  if (window.completedMyraSay) {
                    window.completedMyraSay();
                  }
                }, 500);
              }
              console.log(`[checkCameraSetupImageAPI] TOTAL: ${(performance.now() - t0).toFixed(1)}ms`);
            });
          });
        } catch (err) {
          console.error("Error sending screenshot:", err);
        }
      }
    }
  };

  checkStartSetup = (exerciseData) => {
    this.audioSaidStart = false;

    this.updateTextScreen("Start sending");

    if (document.querySelector("#agora_ondemand_local video")) {
      const videoEl = document.querySelector("#agora_ondemand_local video");
      const videoRatio = videoEl.videoWidth / videoEl.videoHeight;

      let canvasWidth = Math.min(640, this.useWidth);
      let canvasHeight = canvasWidth / videoRatio;

      if (canvasHeight > this.useHeight) {
        canvasHeight = this.useHeight;
        canvasWidth = canvasHeight * videoRatio;
      }

      const canvas = document.createElement("canvas");
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(videoEl, 0, 0, canvas.width, canvas.height);

      var img = canvas.toDataURL();
      img = img ? img.split(",")[1] : null;

      // FORCE CLEANUP
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      canvas.width = 0;
      canvas.height = 0;
      canvas.remove();

      this.updateTextScreen("Start image");

      if (img != null) {
        try {
          this.updateTextScreen("Start API");
          const savedBodyPosition = localStorage.getItem("bodyPosition");
          const bodyPosition = savedBodyPosition ? JSON.parse(savedBodyPosition) : {};

          fetch(this.APIURL + "/api/v1/assessment/processstart", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ imageBase64: img, startjson: JSON.parse(exerciseData), startlandmarks: window["lastLandmarks"] ? window["lastLandmarks"] : [], bodyPosition }),
          }).then((res) => {
            res.json().then((data) => {
              console.log("API Response:", data);
              this.updateTextScreen("Got API back");

              if (data && data.success == false && this.audioSaidStart == false && data.message) {
                window.stopLightAudio();
                if (window.listenMyraStart) {
                  window.listenMyraStart();
                }
                window.mayraCode.doSay(data.message + " If you feel you are in the correct position, just say 'Myra I am in the correct starting position' and I'll start the exercise");
              }
            });
          });
        } catch (err) {
          console.error("Error sending data:", err);
          this.updateTextScreen("Error API");
        }
      }
    }
  };

  stopStartAudio = () => {
    this.audioSaidStart = true;
  };
  stopLightAudio = () => {
    this.audioSaidLight = true;
  };

  updateTextScreen = (texttoshow) => {
    // if ( document.getElementById("debugVoice") ) document.getElementById("debugVoice").innerHTML = texttoshow;

    if (!window.lastLogMessage || window.lastLogMessage !== JSON.stringify(texttoshow)) {
      window.lastLogMessage = JSON.stringify(texttoshow);

      try {
        fetch(this.APIURL + "/api/v1/assessment/saveLogs", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ log: texttoshow }),
        });
      } catch (e) { }
    }
  };

  stopMyraDestroy = () => {
    if (window.VoiceService && window.VoiceService.destroyMyraCompletely) {
      try {
        window.VoiceService.destroyMyraCompletely(true);
        console.warn('Myra closed');
      } catch (e) {
        console.error('Myra error closing', e);
      }
    } else {
      console.error('Myra error missing');
    }

    setTimeout(() => { if (window.mayraForceStop) { window.mayraForceStop(); } }, 2000);
  }

  destroyOwnedResources = () => {
    console.warn("[ondemandCamera] Destroying owned resources");

    // Cancel recovery + watchdog before stopping tracks
    this._cancelRecovery();
    this.cameraActive = false;

    /* ----------------------------------------------------
     * 1. STOP MEDIA STREAMS CREATED BY THIS CLASS
     * -------------------------------------------------- */
    try {
      if (this.localStream) {
        this.localStream.getTracks().forEach(t => {
          try { t.removeEventListener('ended', this.onTrackEnded); } catch (_) { }
          try { t.removeEventListener('mute', this.onTrackMuted); } catch (_) { }
          try { t.stop(); } catch (_) { }
        });
        this.localStream = null;
      }

      if (this.listOfMediaTracks?.length) {
        this.listOfMediaTracks.forEach(stream => {
          if (stream?.getTracks) {
            stream.getTracks().forEach(t => {
              try { t.removeEventListener('ended', this.onTrackEnded); } catch (_) { }
              try { t.removeEventListener('mute', this.onTrackMuted); } catch (_) { }
              try { t.stop(); } catch (_) { }
            });
          }
        });
        this.listOfMediaTracks = [];
      }
    } catch (e) {
      console.warn("Media stream cleanup error", e);
    }

    /* ----------------------------------------------------
     * 2. CLEAN ONLY THE VIDEO CREATED BY THIS FILE
     * -------------------------------------------------- */
    try {
      const container = document.querySelector("#agora_ondemand_local");
      const video = container?.querySelector("video");

      if (video) {
        try {
          video.pause();
          video.srcObject = null;
          video.src = "";
          video.load();
          video.remove();
        } catch (_) { }
      }

      if (container) {
        container.innerHTML = "";
      }
    } catch (e) {
      console.warn("Video cleanup error", e);
    }

    /* ----------------------------------------------------
     * 3. STOP VIRTUAL DETECTION LOOP
     * -------------------------------------------------- */
    this.repeatedDetection = false;

    if (this._loopTimer) {
      clearTimeout(this._loopTimer);
      this._loopTimer = null;
    }

    /* ----------------------------------------------------
     * 4. CLEAN CANVASES OWNED BY THIS CLASS
     * -------------------------------------------------- */
    try {
      if (this.simpleCtx) this.simpleCtx = null;
      if (this.simpleCanvas) {
        this.simpleCanvas.width = 0;
        this.simpleCanvas.height = 0;
        this.simpleCanvas = null;
      }

      this.flutterCanvas = null;
      this.drawContext = null;
      this.drawContext1 = null;
    } catch (e) {
      console.warn("Canvas cleanup error", e);
    }

    /* ----------------------------------------------------
     * 5. CLEAN AUDIO CREATED BY THIS FILE ONLY
     * -------------------------------------------------- */
    try {
      if (this.audio) {
        this.audio.pause();
        this.audio.src = "";
        this.audio.load();
        this.audio = null;
      }
    } catch (_) { }

    /* ----------------------------------------------------
     * 6. RESET INTERNAL STATE / ARRAYS
     * -------------------------------------------------- */
    this.framesArray = [];
    this.hideMasks = [];
    this.listStickMan = [];
    this.doHiding = false;
    this.sizeSetupOnce = false;

    const resetCanvas = (id) => {
      const canvas = document.getElementById(id);
      if (!canvas) return;

      const ctx = canvas.getContext("2d");
      if (!ctx) return;

      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = "source-over";
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Free GPU backing store (Safari-critical)
      const w = canvas.width;
      const h = canvas.height;
      canvas.width = 0;
      canvas.height = 0;
      canvas.width = w;
      canvas.height = h;
    };

    try {
      resetCanvas("canvas-user");
      resetCanvas("canvas-flutter");
    } catch (e) {
      console.warn("React canvas reset error", e);
    }

    console.warn("[ondemandCamera] Owned resource cleanup complete");
  };

  destroyFlutterResources = () => {
    if (window.navigateBlank) { window.navigateBlank(); }

    setTimeout(() => {
      document.querySelectorAll('canvas').forEach(canvas => {
        const gl =
          canvas.getContext('webgl2') ||
          canvas.getContext('webgl') ||
          canvas.getContext('experimental-webgl');

        if (!gl) return;

        const loseExt = gl.getExtension('WEBGL_lose_context');
        if (loseExt) {
          loseExt.loseContext();
        }
      });

      [
        'flt-glass-pane',
        'flt-scene-host',
        'flt-text-editing-host',
        'flt-semantics-host'
      ].forEach(tag => {
        document.querySelectorAll(tag).forEach(el => el.remove());
      });

      document.querySelectorAll('canvas').forEach(c => c.remove());
    }, 2000);
  }

  postSessionReload = () => {
    localStorage.setItem('loadAfterReloadAuto', '1');
    setTimeout(() => { window.location.reload(true); }, 500);
  }

  isMyraUserSpeaking = () => {
    return !!document.getElementById("debugVoice") && !!document.getElementById("debugVoice").innerText;
  }

  forceMyraStatusText = (newStatus) => {
    console.log('MYRA STATUS:', newStatus);

    window.forcedStatusMyra = newStatus;
  }

  myraRestartAssembly = () => {
    if (window.VoiceService && window.VoiceService.resetAssembly) {
      window.VoiceService.resetAssembly();
    }
  }

  recalibrateCameraPreview = () => {
    if (this.cameraActive) {
      const cam = this.getLastPickedCamera();
      this._tearDownVideoElement();
      this.getUserPermission(cam, false, (res) => {
        if (res && this.isIPhoneSafari()) {
          setTimeout(() => {
            this.stretchToFill();
          }, 300);
        }
      });
    }
  };

  getMyraMode = () => {
    return window.MyraInteraction && window.MyraInteraction.getMode && window.MyraInteraction.getMode() == 'chat' ? 'chat' : 'voice';
  }

  doSaySpeed = (sentObj, sentObj1) => {
    console.log('DOSAY SPEED', sentObj, sentObj1);
    window.doSay(sentObj, null, sentObj1);
  }

  listenNative = () => {
    window.hasGetUserMedia = this.hasGetUserMedia;
    window.closeStream = this.closeStream;
    window.turnOffCamera = this.turnOffCamera;
    window.getUserPermission = this.getUserPermission;
    window.startStream = this.startStream;
    window.startMicPermission = this.startMicPermission;
    window.hasCameraAccess = this.hasCameraAccess;
    window.refreshCameraPermission = this.refreshCameraPermission;

    window.getMediaPipePoints = this.getMediaPipePoints;
    window.startVirtualFullDetection = this.startVirtualFullDetection;
    window.stopVirtualFullDetection = this.stopVirtualFullDetection;

    window.getListOfCameras = this.getListOfCameras;
    window.getListOfSpeakers = this.getListOfSpeakers;
    window.speakerTestOnDemand = this.speakerTestOnDemand;
    window.stopSpeakerTestOnDemand = this.stopSpeakerTestOnDemand;
    window.getLastPickedSpeaker = this.getLastPickedSpeaker;
    window.getLastPickedCamera = this.getLastPickedCamera;

    window.getCurrentVideoDevice = this.getCurrentVideoDevice;
    window.getCurrentSpeakerDevice = this.getCurrentSpeakerDevice;

    window.prepareAppJurneyPayload = this.prepareAppJurneyPayload;
    window.showPreparationHost = this.showPreparationHost;
    window.setCameraChoiceSilentFlow = this.setCameraChoiceSilentFlow;
    window.cameraSetupShow = this.cameraSetupShow;
    window.cameraSetupStart = this.cameraSetupStart;
    window.cameraSetupHide = this.cameraSetupHide;
    window.cameraSetupHideCamera = this.cameraSetupHideCamera;
    window.getAppVersion = this.getAppVersion;
    window.getPlatform = this.getPlatform;
    window.setVideoDevice = this.setVideoDevice;
    window.setSpeakerDevice = this.setSpeakerDevice;

    window.saveToJSONFile = this.saveToJSONFile;
    window.updateMasksArray = this.updateMasksArray;
    window.updateStickManArray = this.updateStickManArray;

    window.canvasCapture = this.canvasCapture;
    window.takeScreenshot = this.takeScreenshot;

    window.restartFlutterTransform = this.restartFlutterTransform;

    window.checkIsSelf = this.checkIsSelf;
    window.moveAfterAssesment = this.moveAfterAssesment;
    window.moveAfterAssesmentSave = this.moveAfterAssesmentSave;
    window.closeSelfVirtual = this.closeSelfVirtual;
    window.restartSelfAsses = this.restartSelfAsses;
    window.cameraBoxPosition = this.cameraBoxPosition;
    window.positionCameraView = this.cameraBoxPosition;

    this.getListOfSpeakers();
    this.getListOfCameras();

    window.loadedROM = false;
    //localStorage.setItem('dataAfterInfo', "");

    // this.loadROMExercises();
    window.loadROMExercises = this.loadROMExercises;
    window.getWindowSize = this.getWindowSize;
    window.startMyraClass = this.startMyraClass;
    window.startMyraClassSilent = this.startMyraClassSilent;
    window.isMyraActive = this.isMyraActive;
    window.isMyraUserSpeaking = this.isMyraUserSpeaking;

    window.updateMyName = this.updateMyName;
    window.checkCameraSetupImage = this.checkCameraSetupImage;
    window.checkCameraSetupImageVisible = this.checkCameraSetupImageVisible;
    window.checkStartSetup = this.checkStartSetup;
    window.updateTextScreen = this.updateTextScreen;
    window.getSelfLevel = this.getSelfLevel;

    window.stopStartAudio = this.stopStartAudio;
    window.stopLightAudio = this.stopLightAudio;
    window.updateNewMP = this.updateNewMP;

    window.stopMyraDestroy = this.stopMyraDestroy;
    window.destroyOwnedResources = this.destroyOwnedResources;
    window.destroyFlutterResources = this.destroyFlutterResources;

    window.postSessionReload = this.postSessionReload;
    window.forceMyraStatusText = this.forceMyraStatusText;
    window.myraRestartAssembly = this.myraRestartAssembly;

    window.startHeartbeatSession = CrashRecoveryService.startHeartbeat;
    window.stopHeartbeatSession = CrashRecoveryService.stopHeartbeat;
    window.handleIntentionalExit = CrashRecoveryService.handleIntentionalExit;
    window.clearHeartbeatSession = CrashRecoveryService.clearSession;

    window.didCrashLastTime = CrashRecoveryService.didCrashLastTime;

    window.recalibrateCameraPreview = this.recalibrateCameraPreview;
    window.defineListenCommands = this.defineListenCommands;
    window.onScreenEnter = this.onScreenEnter;

    window.getMyraMode = this.getMyraMode;
    window.doSaySpeed = this.doSaySpeed;

    // Note: visibilitychange, pageshow, focus listeners and the Flutter
    // lifecycle bridge (_cameraResumeFromFlutter / _cameraPauseFromFlutter)
    // are registered in the constructor so they are active immediately on
    // instantiation — before Flutter calls listenNative() — eliminating any
    // timing gap and preventing duplicate registration on multiple calls.
  };
}

export default ondemandCamera;
